
<div class="container d-flex justify-content-center align-items-center" style="margin-top: 130px;">
    <div class="card text-center shadow" style="width: 18rem;">
      <div class="card-body">
        <i class="fas fa-check-circle text-success mb-3" style="font-size: 3rem;"></i>
        <h5 class="card-title">{{ messageType }}</h5>
        <p class="card-text">{{ message }}</p>
      </div>
    </div>
  </div>